var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('h1',[_vm._v(_vm._s(_vm.task.name)+" Related Quality Control Samples")]),_c('quality-control-related-list-table',{attrs:{"task":_vm.task.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }